export const APP_SETUP_COMPLETE = "bonfire/appSetup/APP_SETUP_COMPLETE";
export const APP_SETUP_RESET = "bonfire/appSetup/APP_SETUP_RESET";
export const APP_SETUP_ERROR = "bonfire/appSetup/APP_SETUP_ERROR";

interface AppSetupCompleteAction {
  type: typeof APP_SETUP_COMPLETE;
}

interface AppSetupResetAction {
  type: typeof APP_SETUP_RESET;
}
interface AppSetupErrorAction {
  type: typeof APP_SETUP_ERROR;
  error: any;
}

export type AppSetupAction =
  | AppSetupCompleteAction
  | AppSetupResetAction
  | AppSetupErrorAction;
